export default function AnalysisInsight({ score }) {

  let message = "";
  let color = "";

  if (score >= 70) {
    message = "Your resume is strong. You are ready to apply.";
    color = "bg-green-50 text-green-700";
  } else if (score >= 50) {
    message = "Your resume is decent but needs improvement to stand out.";
    color = "bg-yellow-50 text-yellow-700";
  } else {
    message = "Your resume is not competitive yet. Improve key areas to increase shortlist chances.";
    color = "bg-red-50 text-red-700";
  }

  return (
    <div className={`p-4 rounded-xl ${color}`}>
      <p className="text-sm font-medium">
        💡 {message}
      </p>
    </div>
  );
}